import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function IntegrationPage() {
  const steps = [{
    num: '01',
    title: 'Connect',
    desc: 'Install the Sovereign plugin on your WooCommerce dashboard. Securely authenticate with your KRA PIN.'
  }, {
    num: '02',
    title: 'Configure',
    desc: 'Map your tax classes once. Our intelligent system learns your product catalog structure.'
  }, {
    num: '03',
    title: 'Comply',
    desc: 'Sell as usual. Invoices are generated, signed, and transmitted to KRA instantly in the background.'
  }];
  return <div className="min-h-screen bg-sovereign-navy text-white pt-32 pb-20" data-id="element-212">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-213">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="max-w-3xl mb-24" data-id="element-214">
          <h1 className="text-5xl md:text-7xl font-serif text-white mb-8 leading-tight" data-id="element-215">
            Seamless <br data-id="element-216" />
            <span className="italic text-sovereign-gold" data-id="element-217">Integration</span>
          </h1>
          <p className="text-xl text-gray-400 font-light leading-relaxed" data-id="element-218">
            We believe technology should be felt, not seen. Sovereign eTims
            bridges the gap between your store and the tax authority with an
            invisible, unbreakable bond.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-12 relative" data-id="element-219">
          <div className="hidden md:block absolute top-12 left-0 w-full h-[1px] bg-sovereign-gold/20 -z-10" data-id="element-220" />

          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-sovereign-navy" data-id="element-221">
              <div className="text-6xl font-serif text-sovereign-gold/20 mb-6" data-id="element-222">
                {step.num}
              </div>
              <h3 className="text-2xl font-serif text-white mb-4" data-id="element-223">
                {step.title}
              </h3>
              <p className="text-gray-400 font-light leading-relaxed" data-id="element-224">
                {step.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-32 p-12 bg-sovereign-navy-light border border-sovereign-gold/20 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-225">
          <div data-id="element-226">
            <h4 className="text-2xl font-serif text-white mb-2" data-id="element-227">
              Ready to integrate?
            </h4>
            <p className="text-gray-500 font-light" data-id="element-228">
              Setup takes less than 5 minutes.
            </p>
          </div>
          <div className="flex items-center gap-4 text-sovereign-gold uppercase tracking-widest text-sm font-medium cursor-pointer hover:text-white transition-colors" data-id="element-229">
            View Documentation <ArrowRight className="w-4 h-4" data-id="element-230" />
          </div>
        </motion.div>
      </div>
    </div>;
}